import React, { useState, useEffect, createContext, useContext } from "react";

export type CardProps = {
  id: string;
  title: string;
  client: string;
  due: string;
  count: number;
  amount: number;
  method: string[];
  material: string[];
  status: string;
};

export type Data = CardProps[];

export type DataState = Data;

const initialData: DataState = [];

const DataContext = createContext<{
  loading: boolean;
  data: DataState;
  setData: React.Dispatch<any>;
}>({
  loading: true,
  data: initialData,
  setData: () => null,
});

export default function DataProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [data, setData] = useState<DataState>(initialData);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        "https://aqueous-falls-29835.herokuapp.com/requests"
      );
      const data = await response.json();
      setData(data);
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ loading, data, setData }}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
